var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSchloss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schloss__Icn/40px/Schloss",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Schloss__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Schloss__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.7800993,10.6892268 L23.8657383,10.9013287 L21.9985775,11.6180646 C21.1520234,9.41271601 18.7901522,8.28930639 16.7385184,9.07685481 C14.7490554,9.84053813 13.745161,12.1347751 14.4580489,14.2839948 L14.529934,14.4850082 L15.491,16.9993445 L26,17 C27.1045695,17 28,17.8954305 28,19 L28,29 C28,30.1045695 27.1045695,31 26,31 L14,31 C12.8954305,31 12,30.1045695 12,29 L12,19 C12,18.10965 12.5817914,17.3551847 13.3859463,17.0960319 L12.6627732,15.2017441 C11.428202,11.9855762 12.917394,8.40135707 16.0217825,7.20969396 C19.0571847,6.04451225 22.4755873,7.61247787 23.7800993,10.6892268 Z M26,19 L14,19 L14,29 L26,29 L26,19 Z M20,21 C21.1045695,21 22,21.8954305 22,23 C22,23.7398375 21.5982846,24.3858493 21.0010775,24.7318119 L21,27 L19,27 L18.9999275,24.7323937 C18.4021661,24.3865739 18,23.7402524 18,23 C18,21.8954305 18.8954305,21 20,21 Z",
    id: ".._.._src_svg_Icn_40px_Schloss__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchloss);
export default __webpack_public_path__ + "static/media/Schloss.4e495f4e60878e878ff54e3c75056b6d.svg";
export { ForwardRef as ReactComponent };